import { CARRIER_IS_ACTIVE_DEFAULT } from '../constants';
import * as types from '../types';

function setCarrierActive(state, action) {
    const {
        meta: {
            filterId,
            carrierCode,
            travelMode: travelModeToSet,
        },
        payload: isActive,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            carriers: {
                ...state[filterId].carriers,
                [carrierCode]: {
                    ...state[filterId].carriers[carrierCode],
                    [travelModeToSet]: isActive,
                },
            },
        },
    };
}

function setCarriersActive(state, action) {
    const {
        meta: {
            filterId,
            carrierCodes,
            travelMode: travelModeToSet,
        },
        payload: isActive,
    } = action;

    const updatedCarriers = carrierCodes.reduce((map, carrierCode) => {
        const travelModeMap = state[filterId].carriers[carrierCode] || {};
        const allValue = travelModeMap.all;

        return {
            ...map,
            [carrierCode]: {
                ...Object.entries(travelModeMap)
                    .reduce((map, [travelMode, isActive]) => {
                        if (travelMode === 'all') {
                            return map;
                        }

                        return {
                            ...map,
                            [travelMode]: typeof allValue === 'boolean'
                                ? allValue
                                : isActive,
                        };
                    }, {}),
                [travelModeToSet]: isActive,
            },
        };
    }, {});

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            carriers: {
                ...state[filterId].carriers,
                ...updatedCarriers,
            },
        },
    };
}

function resetCarriers(state, action) {
    const { meta: filterId } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            carriers: Object.entries(state[filterId].carriers)
                .reduce((map, [carrierCode, carrierTravelModeMap]) => ({
                    ...map,
                    [carrierCode]: Object.keys(state[filterId].carriers[carrierCode])
                        .reduce((map, travelMode) => ({
                            ...map,
                            [travelMode]: CARRIER_IS_ACTIVE_DEFAULT,
                        }), {}),
                }), {}),
        },
    };
}

export default {
    [types.SET_CARRIER_ACTIVE]: setCarrierActive,
    [types.SET_CARRIERS_ACTIVE]: setCarriersActive,
    [types.RESET_CARRIERS]: resetCarriers,
};
